module.exports = __webpack_public_path__ + "static/interactive_zoom-b79dc6b88c5e3436802abbbdca917bf3.png";